
import LoginForm from '../../Molecules/Discovery/LoginForm.vue'
import Advantages from '../../Molecules/Discovery/Advantages.vue'
export default {
  props: {
    labels: {
      type: Object,
      default: () => {}
    },
    data: {
      type: Object,
      default: () => {}
    },
    dataResetPassword: {
      type: Object,
      default: () => {}
    },
    resetPasswordFieldsErrors: {
      type: Object,
      default: () => {}
    },
    fieldsErrors: {
      type: Object,
      default: () => {}
    },
    globals: {
      type: Object,
      default: () => {}
    },
    version: {
      type: String,
      default: 'page'
    },
    resetPasswordSubmmited: {
      type: Boolean,
      default: false
    },
    errorLogin: {
      type: String,
      default: ''
    },
    publicPath: {
      type: String,
      default: '/'
    },
    errorReset: {
      type: Boolean,
      default: false
    },
    isBP: {
      type: Boolean,
      default: false
    },
    isLoginModalOpen: {
      type: Boolean,
      default: false
    }
  },
  components: {
    LoginForm,
    Advantages
  }
}
